import { storageListSelect, pageVoucher, delVoucher, inboundDelete, outboundDelete, storageAllDelete, combindDelete, financePaymentDelete, financeOrderDelete, otherExpendDelete, otherIncomeDelete, abandonstate, listNotLeavelStaffByStoreId } from "@/utils/api"
export const list = {
    data() {
        return {
            ipagination: {
                current: 1,
                pageSize: 10,
                showTotal: (total, range) => {
                    return range[0] + "-" + range[1] + " 共" + total + "条"
                },
                showQuickJumper: true,
                showSizeChanger: true,
                total: 100
            },
            formData: {
                startTime: '',
                endTime: '',
                type: '',
                typeName: undefined,
                contactCustomerId: '',
                contactCustomerName: '',
                outboundStorageId: '',
                outboundName: undefined,
                inboundStorageId: '',
                inboundName: undefined,
                voucherState: '',
            },
            agentList: [],
            typeList: [{
                id: 5,
                name: '销售出库'
            }, {
                id: 2,
                name: '销售退货入库'
            }, {
                id: 1,
                name: '采购入库'
            }, {
                id: 6,
                name: '采购退货出库'
            }, {
                id: 12,
                name: '收款单'
            }, {
                id: 11,
                name: '付款单'
            }, {
                id: 14,
                name: '其他收入单'
            }, {
                id: 13,
                name: '其他支出单'
            }, {
                id: 7,
                name: '其他出库'
            }, {
                id: 3,
                name: '其他入库'
            }, {
                id: 8,
                name: '库存报损'
            }, {
                id: 4,
                name: '库存报溢'
            }, {
                id: 9,
                name: '库存调拨 '
            }, {
                id: 10,
                name: '库存组装拆卸单'
            }],
            statusList: [{
                id: 0,
                name: '待审批'
            }, {
                id: 1,
                name: '审批通过'
            }, {
                id: 2,
                name: '审批被拒'
            }],
            statusList2: [{
                id: 1,
                name: '审批通过'
            }, {
                id: 2,
                name: '审批拒绝'
            }, {
                id: 3,
                name: '已关闭'
            }],
            dateValue: null,
            isLoding: false,
            indicator: '<a-icon type="loading" style="font-size: 24px" spin />',
            voucherEntityId: null
        }
    },
    activated() {
        if (this.$route.params.id) {
            this.formData.contactCustomerId = this.$route.params.id
            this.formData.contactCustomerName = this.$route.params.name
        }
        this.getStorageList()
        this.geTroughDraftList()
        this.getStaffListSelect()
        // 绑定enter事件
        this.enterKeyup();
    },
    destroyed() {
        // 销毁enter事件
        this.enterKeyupDestroyed();
    },
    methods: {
        enterKeyup() {
            document.addEventListener("keyup", this.enterKey);
        },
        enterKeyupDestroyed() {
            document.removeEventListener("keyup", this.enterKey);
        },
        // 回车事件
        enterKey(event) {
            const code = event.keyCode ?
                event.keyCode :
                event.which ?
                    event.which :
                    event.charCode;
            if (code == 13) {
                if (this.$route.fullPath == '/bill/billManage/draftDocuments' || this.$route.fullPath == '/bill/billManage/postedDocuments') {
                    this.btnInquire()
                }
            }
        },
        // 选择筛选日期
        changeData(date, dateString) {
            this.dateValue = date
            this.formData.startTime = dateString[0]
            this.formData.endTime = dateString[1]
        },
        // 选择单据类型
        selectBillType(e) {
            this.formData.type = this.typeList[e.key].id
        },
        // 获取类型名称
        getTypeName(e) {
            let name = "";
            this.typeList.map((item) => {
                if (e == item.id) {
                    name = item.name;
                }
            });
            return name;
        },
        // 选择往来单位
        btnReceiptModel() {
            this.$refs.receipt.onOpen(this.formData.contactCustomerName)
        },
        onSelectModel(data) {
            this.formData.contactCustomerId = data.id
            this.formData.contactCustomerName = data.contactCustomerName ? data.contactCustomerName : data.contactName
        },
        changeContactCustomer() {
            if (!this.formData.contactCustomerName) {
                this.formData.contactCustomerId = ''
                this.btnInquire()
            }
        },
        /**
         * 方法说明：获取经办人列表
         * @method getStaffListSelect
         */
        getStaffListSelect() {
            let params = new FormData()
            params.append("companyStoreId", this.$store.state.userInfo.companyStoreId)
            listNotLeavelStaffByStoreId(params).then((res) => {
                if (res.code == 200) {
                    this.agentList = res.result
                } else {
                    this.$message.error(res.logMessage)
                }
            })
        },
        /**
         * 方法说明：选择经办人
         * @method selectAgentList
         * @param {Number} e-经办人列表数据的下标
         */
        selectAgentList(e) {
            this.formData.transactorId = this.agentList[e].id
            this.formData.transactorName = this.agentList[e].name
        },
        // 获取仓库列表
        getStorageList() {
            let params = new FormData()
            params.append("companyStoreId", this.$store.state.userInfo.companyStoreId)
            storageListSelect(params).then((res) => {
                if (res.code == 200) {
                    this.warehouseList = res.result
                } else {
                    this.$message.warn(res.logMessage);
                }
            })
        },
        // 选择出库仓库
        selectoutWarehouse(e) {
            this.formData.outboundStorageId = this.warehouseList[e.key].id
        },
        // 选择入库仓库
        selectinWarehouse(e) {
            this.formData.inboundStorageId = this.warehouseList[e.key].id
        },
        // 选择状态
        selectoutStatus(e) {
            this.formData.voucherState = this.statusList[e.key].id
        },
        // 页面变化时回调
        onChangeIpagination(current) {
            this.ipagination.current = current
            this.geTroughDraftList()
        },
        // 一页显示条数变化时回调
        onShowSizeChange(current, pageSize) {
            this.ipagination.current = current
            this.ipagination.pageSize = pageSize
            this.geTroughDraftList()
        },
        // 切换类型
        callback(e) {
            this.ipagination.current = 1
            this.ipagination.pageSize = 10
            this.queryType = e
            this.btnReset()
            if (document.getElementById("page-top")) {
                this.makeTop = document.getElementById("page-top").offsetHeight * 2;
            }
        },
        // 重置
        btnReset() {
            this.dateValue = null
            this.formData = {
                startTime: '',
                endTime: '',
                type: '',
                contactCustomerId: '',
                contactCustomerName: '',
                outboundStorageId: '',
                inboundStorageId: ''
            }
            this.setIpagination()

        },
        // 根据条件查询
        btnInquire() {
            this.setIpagination()
        },
        setIpagination() {
            this.ipagination = {
                current: 1,
                pageSize: 10,
                showTotal: (total, range) => {
                    return range[0] + "-" + range[1] + " 共" + total + "条"
                },
                showQuickJumper: true,
                showSizeChanger: true,
                total: 100
            }
            this.geTroughDraftList()
        },
        //  获取单据列表列表
        geTroughDraftList() {
            let params = {}
            if (this.queryType) {
                params = {
                    companyId: this.$store.state.userInfo.companyId,
                    companyStoreId: this.$store.state.userInfo.companyStoreId,
                    queryType: parseInt(this.queryType),
                    startDate: this.formData.startTime,
                    endDate: this.formData.endTime,
                    voucherType: this.formData.type,
                    voucherState: this.formData.voucherState,
                    keyword: this.formData.keyword,
                    transactorId: this.formData.transactorId
                }
            } else {
                params = {
                    startTime: this.formData.startTime,
                    endTime: this.formData.endTime,
                    type: this.formData.type,
                    contactCustomerId: this.formData.contactCustomerId,
                    outboundStorageId: this.formData.outboundStorageId,
                    inboundStorageId: this.formData.inboundStorageId,
                    state: this.state,
                    companyStoreId: this.$store.state.userInfo.companyStoreId,
                    keyword: this.formData.keyword,
                    transactorId: this.formData.transactorId
                }
            }
            let data = {
                pageNo: this.ipagination.current,
                pageSize: this.ipagination.pageSize
            }
            this.$store.state.isLoding = true
            pageVoucher(this.urlList.list, params, {}, data).then((res) => {
                if (res.code == 200) {
                    this.$store.state.isLoding = false
                    this.dataSource = res.result.records
                    this.ipagination.total = parseInt(res.result.total)
                } else {
                    this.$message.warn(res.logMessage);
                }
            })
            if (this.queryType) {
                pageVoucher(this.urlList.num, params, {}, data).then((res) => {
                    if (res.code == 200) {
                        res.result.map(item => {
                            if (item.countKey == 'countProcessApprovalingByMe') {
                                this.numObj.countProcessApprovalingByMe = item.countValue
                            } else if (item.countKey == 'countProcessCreatedByMe') {
                                this.numObj.countProcessCreatedByMe = item.countValue
                            } else if (item.countKey == 'countProcessApprovaledByMe') {
                                this.numObj.countProcessApprovaledByMe = item.countValue
                            }
                        })
                    } else {
                        this.$message.warn(res.logMessage);
                    }
                })
            }
        },
        // 删除列表
        btnDeleteList(record) {
            let params = new FormData()
            params.append("voucherEntityId", record.voucherEntityId)
            delVoucher(params).then((res) => {
                if (res.success) {
                    this.$message.success('删除成功')
                    this.geTroughDraftList()
                } else {
                    this.$message.warning(res.logMessage)
                }
            })
        },
        // 废弃
        btnabandoned(record) {
            this.voucherEntityId = record.voucherEntityId
            this.$refs.deleteModel.show({
                content: '您确定要废弃吗？'
            })
        },
        confirmDeletion(record, index) {
            let data = new FormData()
            data.append('companyStoreId', this.$store.state.userInfo.companyStoreId)
            data.append('voucherEntityId', this.voucherEntityId)
            this.$store.state.isLoding = true
            abandonstate(data, {}, {}).then((res) => {
                if (res.success) {
                    this.geTroughDraftList()
                    this.$message.success(res.logMessage)
                } else {
                    this.$message.warn(res.logMessage)
                }
                this.$store.state.isLoding = false
            })
        },
        // 查看详情       // orderType  1为关闭单据   2为已过账  3为审核           auditorType: 人员身份
        btnGoSellOrderDetails(record, orderType, auditorType) {
            let reverseFlag = 1
            let deletId = 2
            let orderId = ''
            if (record.state == 4 || (record.state == 0 && record.reverseFlag == 1)) {
                reverseFlag = 2
            }
            if (record.state == 5) {
                deletId = 1
            }
            if (record.state == 2) {
                orderId = auditorType
                // //审批者
                // if (auditorType == 1 || auditorType == 3) {
                //     orderId = 1
                // }
                //
                // //被审批者
                // if (auditorType == 2) {
                //     orderId = 2
                // }
            } else if (record.state == 3) {
                orderId = auditorType
                // //审批者
                // if (auditorType == 1 || auditorType == 3) {
                //     orderId = 1
                // }
                // //被审批者
                // if (auditorType == 2) {
                //     orderId = 2
                // }
            }
            // 1采购入库 2销售退货入库 3其他入库 4库存报溢 5销售出库 6采购退货出库 7其他出库 8库存报损 9库存调拨 10库存组装拆卸单 11付款单 12收款单 13其他支出单 14其他收入单
            let url = ''
            switch (record.type) {
                case '1':
                    if (orderType == 3) {
                        url = '/bill/modules/billPurchase?id=' + record.id + '&voucherEntityId=' + record.voucherEntityId + '&queryType=' + this.queryType + '&approvalState=' + record.approvalState
                    } else {
                        url = '/bill/modules/billPurchase?voucherEntityId=' + record.voucherEntityId + '&orderType=' + orderType
                    }
                    break
                case '2':
                    if (orderType == 3) {
                        url = '/bill/modules/billMarketReturn?id=' + record.id + '&voucherEntityId=' + record.voucherEntityId + '&queryType=' + this.queryType + '&approvalState=' + record.approvalState
                    } else {
                        url = '/bill/modules/billMarketReturn?voucherEntityId=' + record.voucherEntityId + '&orderType=' + orderType
                    }
                    break
                case '3':
                    if (orderType == 1 || orderType == 2) {
                        url = '/bill/modules/billElseStorage?id=' + record.voucherEntityId + '&reverseFlag=' + reverseFlag + '&deletId=' + deletId
                    } else if (orderType == 3) {
                        url = '/bill/modules/billElseStorage?id=' + record.voucherEntityId + '&order=' + record.id + '&orderId=' + orderId + '&approvalState=' + record.approvalState
                    }
                    break
                case '4':
                    if (orderType == 1 || orderType == 2) {
                        url = '/bill/modules/overflowDetail?id=' + record.voucherEntityId + '&reverseFlag=' + reverseFlag + '&deletId=' + deletId
                    } else if (orderType == 3) {
                        url = '/bill/modules/overflowDetail?id=' + record.voucherEntityId + '&order=' + record.id + '&orderId=' + orderId + '&approvalState=' + record.approvalState
                    }
                    break
                case '5':
                    if (orderType == 3) {
                        url = '/bill/modules/billMarket?id=' + record.id + '&voucherEntityId=' + record.voucherEntityId + '&queryType=' + this.queryType + '&approvalState=' + record.approvalState
                    } else {
                        url = '/bill/modules/billMarket?voucherEntityId=' + record.voucherEntityId + '&orderType=' + orderType
                    }
                    break
                case '6':
                    if (orderType == 3) {
                        url = '/bill/modules/billPurchaseReturn?id=' + record.id + '&voucherEntityId=' + record.voucherEntityId + '&queryType=' + this.queryType + '&approvalState=' + record.approvalState
                    } else {
                        url = '/bill/modules/billPurchaseReturn?voucherEntityId=' + record.voucherEntityId + '&orderType=' + orderType
                    }
                    break
                case '7':
                    if (orderType == 1 || orderType == 2) {
                        url = '/bill/modules/billElseWarehouse?id=' + record.voucherEntityId + '&reverseFlag=' + reverseFlag + '&deletId=' + deletId
                    } else if (orderType == 3) {
                        url = '/bill/modules/billElseWarehouse?id=' + record.voucherEntityId + '&order=' + record.id + '&orderId=' + orderId + '&approvalState=' + record.approvalState
                    }
                    break
                case '8':
                    if (orderType == 1 || orderType == 2) {
                        url = '/bill/modules/lossDetail?id=' + record.voucherEntityId + '&reverseFlag=' + reverseFlag + '&deletId=' + deletId
                    } else if (orderType == 3) {
                        url = '/bill/modules/lossDetail?id=' + record.voucherEntityId + '&order=' + record.id + '&orderId=' + orderId + '&approvalState=' + record.approvalState
                    }
                    break
                case '9':
                    if (orderType == 1 || orderType == 2) {
                        url = '/bill/modules/warehouseDetail?id=' + record.voucherEntityId + '&reverseFlag=' + reverseFlag + '&deletId=' + deletId
                    } else if (orderType == 3) {
                        url = '/bill/modules/warehouseDetail?id=' + record.voucherEntityId + '&order=' + record.id + '&orderId=' + orderId + '&approvalState=' + record.approvalState
                    }
                    break
                case '10':
                    if (orderType == 1 || orderType == 2) {
                        url = '/bill/modules/assemblyDetail?id=' + record.voucherEntityId + '&reverseFlag=' + reverseFlag + '&deletId=' + deletId
                    } else if (orderType == 3) {
                        url = '/bill/modules/assemblyDetail?id=' + record.voucherEntityId + '&order=' + record.id + '&orderId=' + orderId + '&approvalState=' + record.approvalState
                    }
                    break
                case '11':
                    if (orderType == 1 || orderType == 2) {
                        url = '/bill/modules/billPayment?id=' + record.voucherEntityId + '&reverseFlag=' + reverseFlag + '&deletId=' + deletId
                    } else if (orderType == 3) {
                        url = '/bill/modules/billPayment?id=' + record.voucherEntityId + '&order=' + record.id + '&orderId=' + orderId + '&approvalState=' + record.approvalState
                    }
                    break
                case '12':
                    if (orderType == 1 || orderType == 2) {
                        url = '/bill/modules/billProceeds?id=' + record.voucherEntityId + '&reverseFlag=' + reverseFlag + '&deletId=' + deletId
                    } else if (orderType == 3) {
                        url = '/bill/modules/billProceeds?id=' + record.voucherEntityId + '&order=' + record.id + '&orderId=' + orderId + '&approvalState=' + record.approvalState
                    }
                    break
                case '13':
                    if (orderType == 1 || orderType == 2) {
                        url = '/bill/modules/billDisburse?id=' + record.voucherEntityId + '&reverseFlag=' + reverseFlag + '&deletId=' + deletId
                    } else if (orderType == 3) {
                        url = '/bill/modules/billDisburse?id=' + record.voucherEntityId + '&order=' + record.id + '&orderId=' + orderId + '&approvalState=' + record.approvalState
                    }
                    break
                case '14':
                    if (orderType == 1 || orderType == 2) {
                        url = '/bill/modules/billIncome?id=' + record.voucherEntityId + '&reverseFlag=' + reverseFlag + '&deletId=' + deletId
                    } else if (orderType == 3) {
                        url = '/bill/modules/billIncome?id=' + record.voucherEntityId + '&order=' + record.id + '&orderId=' + orderId + '&approvalState=' + record.approvalState
                    }
                    break
                default:
                    url = ''
            }
            this.$router.push({ path: url })
        },
        // 第一次拒绝后  进入编辑也修改再次提交
        btnGoSellOrderEditDetails(record) {
            // 1采购入库 2销售退货入库 3其他入库 4库存报溢 5销售出库 6采购退货出库 7其他出库 8库存报损 9库存调拨 10库存组装拆卸单 11付款单 12收款单 13其他支出单 14其他收入单
            let url = ''
            if (record.approvalState == 5) {
                switch (record.type) {
                    case '1':
                        url = '/purchase/purchaseasmin/purchaseEnterWarehouseEdit?id=' + record.voucherEntityId
                        break
                    case '2':
                        url = '/sales/selladmin/enterWarehouseEdit?id=' + record.voucherEntityId
                        break
                    case '3':
                        url = '/librarymanage/warehousemanage/OtheerWarehousingEdit?id=' + record.voucherEntityId
                        break
                    case '4':
                        url = '/librarymanage/warehousemanage/InventoryOverflowEdit?id=' + record.voucherEntityId
                        break
                    case '5':
                        url = '/sales/selladmin/comeWarehouseEdit?id=' + record.voucherEntityId
                        break
                    case '6':
                        url = '/purchase/purchaseasmin/purchaseGoWarehouseEdit?id=' + record.voucherEntityId
                        break
                    case '7':
                        url = '/librarymanage/warehousemanage/OtheerWarehouEdit?id=' + record.voucherEntityId
                        break
                    case '8':
                        url = '/librarymanage/warehousemanage/InventoryLossReportEdit?id=' + record.voucherEntityId
                        break
                    case '9':
                        url = '/librarymanage/warehousemanage/warehousemanageEdit?id=' + record.voucherEntityId
                        break
                    case '10':
                        url = '/librarymanage/warehousemanage/assemblyDisEdit?id=' + record.voucherEntityId
                        break
                    case '11':
                        url = '/finance/voucher/paymentOrderEdit?id=' + record.voucherEntityId
                        break
                    case '12':
                        url = '/finance/voucher/receiptOrderEdit?id=' + record.voucherEntityId
                        break
                    case '13':
                        url = '/finance/voucher/otherExpensesEdit?id=' + record.voucherEntityId
                        break
                    case '14':
                        url = '/finance/voucher/otherRevenueEdit?id=' + record.voucherEntityId
                        break
                    default:
                        url = ''
                }
            } else {
                switch (record.type) {
                    case '1':
                        url = '/purchase/purchaseasmin/purchaseEnterWarehouseEdit?id=' + record.voucherEntityId + '&btntype=1'
                        break
                    case '2':
                        url = '/sales/selladmin/enterWarehouseEdit?id=' + record.voucherEntityId + '&btntype=1'
                        break
                    case '3':
                        url = '/librarymanage/warehousemanage/OtheerWarehousingEdit?id=' + record.voucherEntityId + '&type=1'
                        break
                    case '4':
                        url = '/librarymanage/warehousemanage/InventoryOverflowEdit?id=' + record.voucherEntityId + '&type=1'
                        break
                    case '5':
                        url = '/sales/selladmin/comeWarehouseEdit?id=' + record.voucherEntityId + '&btntype=1'
                        break
                    case '6':
                        url = '/purchase/purchaseasmin/purchaseGoWarehouseEdit?id=' + record.voucherEntityId + '&btntype=1'
                        break
                    case '7':
                        url = '/librarymanage/warehousemanage/OtheerWarehouEdit?id=' + record.voucherEntityId + '&type=1'
                        break
                    case '8':
                        url = '/librarymanage/warehousemanage/InventoryLossReportEdit?id=' + record.voucherEntityId + '&type=1'
                        break
                    case '9':
                        url = '/librarymanage/warehousemanage/warehousemanageEdit?id=' + record.voucherEntityId + '&type=1'
                        break
                    case '10':
                        url = '/librarymanage/warehousemanage/assemblyDisEdit?id=' + record.voucherEntityId + '&type=1'
                        break
                    case '11':
                        url = '/finance/voucher/paymentOrderEdit?id=' + record.voucherEntityId + '&type=1'
                        break
                    case '12':
                        url = '/finance/voucher/receiptOrderEdit?id=' + record.voucherEntityId + '&type=1'
                        break
                    case '13':
                        url = '/finance/voucher/otherExpensesEdit?id=' + record.voucherEntityId + '&type=1'
                        break
                    case '14':
                        url = '/finance/voucher/otherRevenueEdit?id=' + record.voucherEntityId + '&type=1'
                        break
                    default:
                        url = ''
                }
            }
            this.$router.push({ path: url })
        },
        //删除
        onDeleteOrder(record, index) {
            this.$store.state.isLoding = true
            if (record.type == '1' || record.type == '2' || record.type == '3' || record.type == '4') {
                inboundDelete({}, {}, {
                    companyStoreId: this.$store.state.shopId,
                    id: record.voucherEntityId
                }).then((res) => {
                    if (res.success) {
                        this.$message.success('删除成功')
                        if (index == 2) {
                            this.geTroughDraftList()
                        } else {
                            this.$store.state.closePath = this.$route.fullPath
                        }
                    } else {
                        this.$message.warn(res.logMessage)
                    }
                })
            } else if (record.type == '5' || record.type == '6' || record.type == '7' || record.type == '8') {
                outboundDelete({}, {}, {
                    companyStoreId: this.$store.state.shopId,
                    id: record.voucherEntityId
                }).then((res) => {
                    if (res.success) {
                        this.$message.success('删除成功')
                        if (index == 2) {
                            this.geTroughDraftList()
                        } else {
                            this.$store.state.closePath = this.$route.fullPath
                        }
                    } else {
                        this.$message.warn(res.logMessage)
                    }
                })
            } else if (record.type == '9') {
                storageAllDelete({}, {}, {
                    companyStoreId: this.$store.state.shopId,
                    id: record.voucherEntityId
                }).then((res) => {
                    if (res.success) {
                        this.$message.success('删除成功')
                        if (index == 2) {
                            this.geTroughDraftList()
                        } else {
                            this.$store.state.closePath = this.$route.fullPath
                        }
                    } else {
                        this.$message.warn(res.logMessage)
                    }
                })
            } else if (record.type == '10') {
                combindDelete({}, {}, {
                    companyStoreId: this.$store.state.shopId,
                    id: record.voucherEntityId
                }).then((res) => {
                    if (res.success) {
                        this.$message.success('删除成功')
                        if (index == 2) {
                            this.geTroughDraftList()
                        } else {
                            this.$store.state.closePath = this.$route.fullPath
                        }
                    } else {
                        this.$message.warn(res.logMessage)
                    }
                })
            } else if (record.type == '11') {
                financePaymentDelete({}, {}, {
                    companyStoreId: this.$store.state.shopId,
                    id: record.voucherEntityId
                }).then((res) => {
                    if (res.success) {
                        this.$message.success('删除成功')
                        if (index == 2) {
                            this.geTroughDraftList()
                        } else {
                            this.$store.state.closePath = this.$route.fullPath
                        }
                    } else {
                        this.$message.warn(res.logMessage)
                    }
                })
            } else if (record.type == '12') {
                financeOrderDelete({}, {}, {
                    companyStoreId: this.$store.state.shopId,
                    id: record.voucherEntityId
                }).then((res) => {
                    if (res.success) {
                        this.$message.success('删除成功')
                        if (index == 2) {
                            this.geTroughDraftList()
                        } else {
                            this.$store.state.closePath = this.$route.fullPath
                        }
                    } else {
                        this.$message.warn(res.logMessage)
                    }
                })
            } else if (record.type == '13') {
                otherExpendDelete({}, {}, {
                    companyStoreId: this.$store.state.shopId,
                    id: record.voucherEntityId
                }).then((res) => {
                    if (res.success) {
                        this.$message.success('删除成功')
                        if (index == 2) {
                            this.geTroughDraftList()
                        } else {
                            this.$store.state.closePath = this.$route.fullPath
                        }
                    } else {
                        this.$message.warn(res.logMessage)
                    }
                })
            } else if (record.type == '14') {
                otherIncomeDelete({}, {}, {
                    companyStoreId: this.$store.state.shopId,
                    id: record.voucherEntityId
                }).then((res) => {
                    if (res.success) {
                        this.$message.success('删除成功')
                        if (index == 2) {
                            this.geTroughDraftList()
                        } else {
                            this.$store.state.closePath = this.$route.fullPath
                        }
                    } else {
                        this.$message.warn(res.logMessage)
                    }
                })
            }
        },
    }
}